// # Nationality data with flags and search keys
export const nationalityData = {
  // # Arab Countries
  EGYPT: { name: 'Egypt', flag: '🇪🇬', searchKeys: ['egypt', 'مصر', 'arab'] },
  ALGERIA: { name: 'Algeria', flag: '🇩🇿', searchKeys: ['algeria', 'الجزائر', 'arab'] },
  BAHRAIN: { name: 'Bahrain', flag: '🇧🇭', searchKeys: ['bahrain', 'البحرين', 'arab'] },
  COMOROS: { name: 'Comoros', flag: '🇰🇲', searchKeys: ['comoros', 'جزر القمر', 'arab'] },
  DJIBOUTI: { name: 'Djibouti', flag: '🇩🇯', searchKeys: ['djibouti', 'جيبوتي', 'arab'] },
  IRAQ: { name: 'Iraq', flag: '🇮🇶', searchKeys: ['iraq', 'العراق', 'arab'] },
  JORDAN: { name: 'Jordan', flag: '🇯🇴', searchKeys: ['jordan', 'الأردن', 'arab'] },
  KUWAIT: { name: 'Kuwait', flag: '🇰🇼', searchKeys: ['kuwait', 'الكويت', 'arab'] },
  LEBANON: { name: 'Lebanon', flag: '🇱🇧', searchKeys: ['lebanon', 'لبنان', 'arab'] },
  LIBYA: { name: 'Libya', flag: '🇱🇾', searchKeys: ['libya', 'ليبيا', 'arab'] },
  MAURITANIA: { name: 'Mauritania', flag: '🇲🇷', searchKeys: ['mauritania', 'موريتانيا', 'arab'] },
  MOROCCO: { name: 'Morocco', flag: '🇲🇦', searchKeys: ['morocco', 'المغرب', 'arab'] },
  OMAN: { name: 'Oman', flag: '🇴🇲', searchKeys: ['oman', 'عمان', 'arab'] },
  PALESTINE: { name: 'Palestine', flag: '🇵🇸', searchKeys: ['palestine', 'فلسطين', 'arab'] },
  QATAR: { name: 'Qatar', flag: '🇶🇦', searchKeys: ['qatar', 'قطر', 'arab'] },
  SAUDI_ARABIA: { name: 'Saudi Arabia', flag: '🇸🇦', searchKeys: ['saudi', 'arabia', 'السعودية', 'arab'] },
  SOMALIA: { name: 'Somalia', flag: '🇸🇴', searchKeys: ['somalia', 'الصومال', 'arab'] },
  SUDAN: { name: 'Sudan', flag: '🇸🇩', searchKeys: ['sudan', 'السودان', 'arab'] },
  SYRIA: { name: 'Syria', flag: '🇸🇾', searchKeys: ['syria', 'سوريا', 'arab'] },
  TUNISIA: { name: 'Tunisia', flag: '🇹🇳', searchKeys: ['tunisia', 'تونس', 'arab'] },
  UAE: { name: 'United Arab Emirates', flag: '🇦🇪', searchKeys: ['uae', 'emirates', 'الإمارات', 'arab'] },
  YEMEN: { name: 'Yemen', flag: '🇾🇪', searchKeys: ['yemen', 'اليمن', 'arab'] },

  // # Asia
  AFGHANISTAN: { name: 'Afghanistan', flag: '🇦🇫', searchKeys: ['afghanistan', 'asia'] },
  BANGLADESH: { name: 'Bangladesh', flag: '🇧🇩', searchKeys: ['bangladesh', 'asia'] },
  BHUTAN: { name: 'Bhutan', flag: '🇧🇹', searchKeys: ['bhutan', 'asia'] },
  BRUNEI: { name: 'Brunei', flag: '🇧🇳', searchKeys: ['brunei', 'asia'] },
  CAMBODIA: { name: 'Cambodia', flag: '🇰🇭', searchKeys: ['cambodia', 'asia'] },
  CHINA: { name: 'China', flag: '🇨🇳', searchKeys: ['china', 'asia'] },
  HONG_KONG: { name: 'Hong Kong', flag: '🇭🇰', searchKeys: ['hong kong', 'asia'] },
  INDIA: { name: 'India', flag: '🇮🇳', searchKeys: ['india', 'asia'] },
  INDONESIA: { name: 'Indonesia', flag: '🇮🇩', searchKeys: ['indonesia', 'asia'] },
  IRAN: { name: 'Iran', flag: '🇮🇷', searchKeys: ['iran', 'asia'] },
  JAPAN: { name: 'Japan', flag: '🇯🇵', searchKeys: ['japan', 'asia'] },
  KAZAKHSTAN: { name: 'Kazakhstan', flag: '🇰🇿', searchKeys: ['kazakhstan', 'asia'] },
  KYRGYZSTAN: { name: 'Kyrgyzstan', flag: '🇰🇬', searchKeys: ['kyrgyzstan', 'asia'] },
  LAOS: { name: 'Laos', flag: '🇱🇦', searchKeys: ['laos', 'asia'] },
  MACAU: { name: 'Macau', flag: '🇲🇴', searchKeys: ['macau', 'asia'] },
  MALAYSIA: { name: 'Malaysia', flag: '🇲🇾', searchKeys: ['malaysia', 'asia'] },
  MALDIVES: { name: 'Maldives', flag: '🇲🇻', searchKeys: ['maldives', 'asia'] },
  MONGOLIA: { name: 'Mongolia', flag: '🇲🇳', searchKeys: ['mongolia', 'asia'] },
  MYANMAR: { name: 'Myanmar', flag: '🇲🇲', searchKeys: ['myanmar', 'burma', 'asia'] },
  NEPAL: { name: 'Nepal', flag: '🇳🇵', searchKeys: ['nepal', 'asia'] },
  NORTH_KOREA: { name: 'North Korea', flag: '🇰🇵', searchKeys: ['north korea', 'asia'] },
  PAKISTAN: { name: 'Pakistan', flag: '🇵🇰', searchKeys: ['pakistan', 'asia'] },
  PHILIPPINES: { name: 'Philippines', flag: '🇵🇭', searchKeys: ['philippines', 'asia'] },
  SINGAPORE: { name: 'Singapore', flag: '🇸🇬', searchKeys: ['singapore', 'asia'] },
  SOUTH_KOREA: { name: 'South Korea', flag: '🇰🇷', searchKeys: ['south korea', 'asia'] },
  SRI_LANKA: { name: 'Sri Lanka', flag: '🇱🇰', searchKeys: ['sri lanka', 'asia'] },
  TAIWAN: { name: 'Taiwan', flag: '🇹🇼', searchKeys: ['taiwan', 'asia'] },
  THAILAND: { name: 'Thailand', flag: '🇹🇭', searchKeys: ['thailand', 'asia'] },
  TIMOR_LESTE: { name: 'Timor-Leste', flag: '🇹🇱', searchKeys: ['timor', 'asia'] },
  TURKEY: { name: 'Turkey', flag: '🇹🇷', searchKeys: ['turkey', 'türkiye', 'asia'] },
  TURKMENISTAN: { name: 'Turkmenistan', flag: '🇹🇲', searchKeys: ['turkmenistan', 'asia'] },
  UZBEKISTAN: { name: 'Uzbekistan', flag: '🇺🇿', searchKeys: ['uzbekistan', 'asia'] },
  VIETNAM: { name: 'Vietnam', flag: '🇻🇳', searchKeys: ['vietnam', 'asia'] },

  // # Europe
  UK: { name: 'United Kingdom', flag: '🇬🇧', searchKeys: ['uk', 'britain', 'england', 'europe'] },
  GERMANY: { name: 'Germany', flag: '🇩🇪', searchKeys: ['germany', 'deutschland', 'europe'] },
  FRANCE: { name: 'France', flag: '🇫🇷', searchKeys: ['france', 'europe'] },
  ITALY: { name: 'Italy', flag: '🇮🇹', searchKeys: ['italy', 'italia', 'europe'] },
  SPAIN: { name: 'Spain', flag: '🇪🇸', searchKeys: ['spain', 'españa', 'europe'] },
  PORTUGAL: { name: 'Portugal', flag: '🇵🇹', searchKeys: ['portugal', 'europe'] },
  NETHERLANDS: { name: 'Netherlands', flag: '🇳🇱', searchKeys: ['netherlands', 'holland', 'europe'] },
  BELGIUM: { name: 'Belgium', flag: '🇧🇪', searchKeys: ['belgium', 'europe'] },
  SWITZERLAND: { name: 'Switzerland', flag: '🇨🇭', searchKeys: ['switzerland', 'europe'] },
  AUSTRIA: { name: 'Austria', flag: '🇦🇹', searchKeys: ['austria', 'europe'] },
  SWEDEN: { name: 'Sweden', flag: '🇸🇪', searchKeys: ['sweden', 'europe'] },
  NORWAY: { name: 'Norway', flag: '🇳🇴', searchKeys: ['norway', 'europe'] },
  DENMARK: { name: 'Denmark', flag: '🇩🇰', searchKeys: ['denmark', 'europe'] },
  FINLAND: { name: 'Finland', flag: '🇫🇮', searchKeys: ['finland', 'europe'] },
  IRELAND: { name: 'Ireland', flag: '🇮🇪', searchKeys: ['ireland', 'europe'] },
  GREECE: { name: 'Greece', flag: '🇬🇷', searchKeys: ['greece', 'europe'] },
  POLAND: { name: 'Poland', flag: '🇵🇱', searchKeys: ['poland', 'europe'] },
  ROMANIA: { name: 'Romania', flag: '🇷🇴', searchKeys: ['romania', 'europe'] },
  HUNGARY: { name: 'Hungary', flag: '🇭🇺', searchKeys: ['hungary', 'europe'] },
  CZECH_REPUBLIC: { name: 'Czech Republic', flag: '🇨🇿', searchKeys: ['czech', 'europe'] },
  SLOVAKIA: { name: 'Slovakia', flag: '🇸🇰', searchKeys: ['slovakia', 'europe'] },
  CROATIA: { name: 'Croatia', flag: '🇭🇷', searchKeys: ['croatia', 'europe'] },
  SERBIA: { name: 'Serbia', flag: '🇷🇸', searchKeys: ['serbia', 'europe'] },
  BULGARIA: { name: 'Bulgaria', flag: '🇧🇬', searchKeys: ['bulgaria', 'europe'] },
  UKRAINE: { name: 'Ukraine', flag: '🇺🇦', searchKeys: ['ukraine', 'europe'] },
  RUSSIA: { name: 'Russia', flag: '🇷🇺', searchKeys: ['russia', 'europe', 'asia'] },

  // # Americas
  USA: { name: 'United States', flag: '🇺🇸', searchKeys: ['usa', 'united states', 'america', 'americas'] },
  CANADA: { name: 'Canada', flag: '🇨🇦', searchKeys: ['canada', 'americas'] },
  BRAZIL: { name: 'Brazil', flag: '🇧🇷', searchKeys: ['brazil', 'brasil', 'americas'] },
  MEXICO: { name: 'Mexico', flag: '🇲🇽', searchKeys: ['mexico', 'méxico', 'americas'] },
  ARGENTINA: { name: 'Argentina', flag: '🇦🇷', searchKeys: ['argentina', 'americas'] },
  CHILE: { name: 'Chile', flag: '🇨🇱', searchKeys: ['chile', 'americas'] },
  COLOMBIA: { name: 'Colombia', flag: '🇨🇴', searchKeys: ['colombia', 'americas'] },
  PERU: { name: 'Peru', flag: '🇵🇪', searchKeys: ['peru', 'perú', 'americas'] },
  VENEZUELA: { name: 'Venezuela', flag: '🇻🇪', searchKeys: ['venezuela', 'americas'] },
  ECUADOR: { name: 'Ecuador', flag: '🇪🇨', searchKeys: ['ecuador', 'americas'] },
  BOLIVIA: { name: 'Bolivia', flag: '🇧🇴', searchKeys: ['bolivia', 'americas'] },
  PARAGUAY: { name: 'Paraguay', flag: '🇵🇾', searchKeys: ['paraguay', 'americas'] },
  URUGUAY: { name: 'Uruguay', flag: '🇺🇾', searchKeys: ['uruguay', 'americas'] },
  COSTA_RICA: { name: 'Costa Rica', flag: '🇨🇷', searchKeys: ['costa rica', 'americas'] },
  PANAMA: { name: 'Panama', flag: '🇵🇦', searchKeys: ['panama', 'americas'] },

  // # Africa (Non-Arab)
  SOUTH_AFRICA: { name: 'South Africa', flag: '🇿🇦', searchKeys: ['south africa', 'africa'] },
  NIGERIA: { name: 'Nigeria', flag: '🇳🇬', searchKeys: ['nigeria', 'africa'] },
  KENYA: { name: 'Kenya', flag: '🇰🇪', searchKeys: ['kenya', 'africa'] },
  ETHIOPIA: { name: 'Ethiopia', flag: '🇪🇹', searchKeys: ['ethiopia', 'africa'] },
  GHANA: { name: 'Ghana', flag: '🇬🇭', searchKeys: ['ghana', 'africa'] },
  TANZANIA: { name: 'Tanzania', flag: '🇹🇿', searchKeys: ['tanzania', 'africa'] },
  UGANDA: { name: 'Uganda', flag: '🇺🇬', searchKeys: ['uganda', 'africa'] },
  SENEGAL: { name: 'Senegal', flag: '🇸🇳', searchKeys: ['senegal', 'africa'] },
  CAMEROON: { name: 'Cameroon', flag: '🇨🇲', searchKeys: ['cameroon', 'africa'] },
  IVORY_COAST: { name: 'Ivory Coast', flag: '🇨🇮', searchKeys: ['ivory coast', 'côte d\'ivoire', 'africa'] },

  // # Oceania
  AUSTRALIA: { name: 'Australia', flag: '🇦🇺', searchKeys: ['australia', 'oceania'] },
  NEW_ZEALAND: { name: 'New Zealand', flag: '🇳🇿', searchKeys: ['new zealand', 'oceania'] },
  FIJI: { name: 'Fiji', flag: '🇫🇯', searchKeys: ['fiji', 'oceania'] },
  PAPUA_NEW_GUINEA: { name: 'Papua New Guinea', flag: '🇵🇬', searchKeys: ['papua new guinea', 'oceania'] },
  SAMOA: { name: 'Samoa', flag: '🇼🇸', searchKeys: ['samoa', 'oceania'] },
  SOLOMON_ISLANDS: { name: 'Solomon Islands', flag: '🇸🇧', searchKeys: ['solomon islands', 'oceania'] },
  VANUATU: { name: 'Vanuatu', flag: '🇻🇺', searchKeys: ['vanuatu', 'oceania'] }
}; 